var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: _vm.computedClasses },
    [
      _c(
        "div",
        { class: { "input-group": _vm.grpPrependSlot || _vm.grpAppendSlot } },
        [
          _vm.grpPrependSlot
            ? _c(
                "div",
                { staticClass: "input-group-prepend" },
                [_vm._t("grpPrepend")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "city-select",
            class: [_vm.inputClasses, { "vs--selected": _vm.hasValue }],
            attrs: {
              name: _vm.name,
              inputId: _vm.id,
              label: _vm.label,
              autocomplete: _vm.autocomplete,
              placeholder: _vm.placeholder,
              filterable: _vm.filterable,
              options: _vm.optionsList,
              clearable: _vm.clearable,
              searchable: _vm.searchable,
              multiple: _vm.multiple,
              reduce: _vm.reduceItem,
              noDrop: _vm.noDrop,
              disabled: _vm.disabled,
              resetOnOptionsChange: _vm.resetOnOptionsChange,
            },
            on: {
              input: _vm.handleModelInput,
              "search:focus": function ($event) {
                return _vm.handleFocus(true)
              },
              "search:blur": function ($event) {
                return _vm.handleFocus(false)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      _vm._t(
                        "selected-option",
                        function () {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.label in option ? option[_vm.label] : ""
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                        { option: option, label: _vm.label }
                      ),
                    ]
                  },
                },
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _vm._t(
                        "option",
                        function () {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  "label" in option
                                    ? option["label"]
                                    : _vm.label in option
                                    ? option[_vm.label]
                                    : ""
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                        { option: option, label: _vm.label }
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.valueCopy,
              callback: function ($$v) {
                _vm.valueCopy = $$v
              },
              expression: "valueCopy",
            },
          }),
          _vm._v(" "),
          _vm.grpAppendSlot
            ? _c(
                "div",
                { staticClass: "input-group-append" },
                [_vm._t("grpAppend")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "material-label",
              class: _vm.activeClass,
              attrs: { for: _vm.id },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.error
            ? _c("small", { staticClass: "invalid-feedback" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("HelpSpan", { attrs: { helpText: _vm.helpText } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }